import React, { useState } from 'react';
import { Upload, FileText, Lock } from 'lucide-react';
import { STEP, stepIcon } from './ToolkitFileStep';

// Toolkit step: choose a file that is read IN THE BROWSER and never uploaded — for files holding guest or card data the
// check does not need a server for (PEP Balancing). onFile(content, file) receives the text (or an ArrayBuffer with
// asBuffer) and may be async; whatever it resolves to as a string is shown as the step's message.

function ToolkitLocalFileStep({ number, title, label, accept, asBuffer = false, onFile, disabled, children }) {
    const [state, setState] = useState({ state: STEP.IDLE, message: '' });
    const pick = async (e) => {
        const file = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!file) return;
        setState({ state: STEP.BUSY, message: `Reading ${file.name}…` });
        try {
            const content = asBuffer ? await file.arrayBuffer() : await file.text();
            const msg = await onFile(content, file);
            setState({ state: STEP.DONE, message: typeof msg === 'string' ? msg : file.name });
        } catch (err) {
            setState({ state: STEP.ERROR, message: `Could not read ${file.name}: ${err.message}` });
        }
    };
    return (
        <div className="tkb-step">
            <div className="tkb-step-head"><span className="tkb-num">{number}</span> {title} {stepIcon(state.state)}</div>
            <label className={`tkb-file${disabled ? ' tkb-file-disabled' : ''}`}>
                <Upload size={15} /> {label}
                <input type="file" accept={accept} onChange={pick} hidden disabled={disabled} />
            </label>
            <span className="tkb-hint" style={{ marginLeft: '0.6rem' }}><Lock size={12} /> Read in your browser — not uploaded.</span>
            {state.message && <p className={`tkb-msg${state.state === STEP.ERROR ? ' tkb-fail' : ''}`}><FileText size={13} /> {state.message}</p>}
            {children}
        </div>
    );
}

export default ToolkitLocalFileStep;
